import { UI } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { usePrivatePensionAssetContext } from '../../../../../../../../BatchTicket/components/DynamicAsset/contexts/products/PrivatePension';
import { useGlobalProductContext } from '../../../../../contexts';
import { availableProductPrivatePensionConstant } from '../constants';

import { PrivatePensionItemTypes } from '.';

export const PrivatePensionItemDesktop: React.FC<PrivatePensionItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = usePrivatePensionAssetContext();
  const { product } = useGlobalProductContext();

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected({ ...offer, accountId: 0 });
  };

  const getFlex = (index: number) => {
    const currentHead = availableProductPrivatePensionConstant.tableHead.find(
      (_, i) => i === index
    );
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']} h="80px">
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <UI.Tooltip testID="details-tooltip" label="Ver detalhes">
          <Pressable onPress={onOpenDetailsModal}>
            <UI.Icon name="Info" size="xs" />
          </Pressable>
        </UI.Tooltip>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{offer.productNameNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{offer.productTypeNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{offer.monthlyRentabilityNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemText>{offer.annualRentabilityNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>{offer.twelveMonthsRentabilityNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TableContentItemText>{offer.minimumApplicationNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(7)}>
        <TableContentItemText>{offer.initialDateNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(8)}>
        <TableContentItemText>{offer.referenceDateNormalized}</TableContentItemText>
      </TableContentItemColumn>
    </TableContent>
  );
};
